import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

export default class CacheStorage {
  public static async set(key: string, value: string | undefined) {
    if (!value) {
      return this.delete(key);
    }
    if (Platform.OS === 'web') {
      return localStorage.setItem(key, value);
    }
    return AsyncStorage.setItem(key, value);
  }

  public static async get(key: string) {
    if (Platform.OS === 'web') {
      return localStorage.getItem(key);
    }
    return AsyncStorage.getItem(key);
  }

  public static async delete(key: string) {
    if (Platform.OS === 'web') {
      return localStorage.removeItem(key);
    }
    return AsyncStorage.removeItem(key);
  }

  public static async clear() {
    if (Platform.OS === 'web') {
      return localStorage.clear();
    }
    return AsyncStorage.clear();
  }
}
